// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2OEXc","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__WnKVD"};